'use client'

import React, {
  ReactElement,
  cloneElement,
  useEffect,
  useRef,
  useState,
} from 'react'

interface CollapsableHeaderProps {
  children: ReactElement<Record<string, unknown>>
}

export const CollapsableHeader = ({ children }: CollapsableHeaderProps) => {
  const lastScrollRef = useRef(0)
  const [isScrollingUp, setIsScrollingUp] = useState(true)
  const [isAtTop, setIsAtTop] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      // clamping the value to be always positive, on Apple devices it can be negative
      // due to elastic scroll
      const scrollTop = Math.max(
        0,
        window.pageYOffset || document.documentElement.scrollTop
      )

      setIsScrollingUp(scrollTop <= lastScrollRef.current)
      setIsAtTop(scrollTop === 0)
      lastScrollRef.current = scrollTop
    }

    handleScroll()

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return <>{cloneElement(children, { isScrollingUp, isAtTop })}</>
}
